import { render, staticRenderFns } from "./ProgramDialog.vue?vue&type=template&id=95884a4c&scoped=true"
import script from "./ProgramDialog.vue?vue&type=script&lang=ts"
export * from "./ProgramDialog.vue?vue&type=script&lang=ts"
import style0 from "./ProgramDialog.vue?vue&type=style&index=0&id=95884a4c&prod&lang=sass&scoped=true"
import style1 from "./ProgramDialog.vue?vue&type=style&index=1&id=95884a4c&prod&lang=sass"
import style2 from "./ProgramDialog.vue?vue&type=style&index=2&id=95884a4c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95884a4c",
  null
  
)

export default component.exports